import { useApiStore } from '@/stores/apiStore';
import { OrgCompassDevicesApi } from '@/../generated-client/apis/OrgCompassDevicesApi';
import type { OrgCompassDeviceListItem } from '@/models/OrgCompassDevice/OrgCompassDeviceListItem';

let orgCompassDevicesApi: OrgCompassDevicesApi | null = null;
let lastConfig: unknown = null;

function getOrgCompassDevicesApi(): OrgCompassDevicesApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (orgCompassDevicesApi === null || lastConfig !== apiConfig) {
    orgCompassDevicesApi = new OrgCompassDevicesApi(apiConfig);
    lastConfig = apiConfig;
  }

  return orgCompassDevicesApi;
}

// Element type of the generated GetAll response, without naming the model.
type GeneratedOrgCompassDevice = Awaited<
  ReturnType<OrgCompassDevicesApi['apiOrgCompassDevicesGetAllGet']>
>[number];

function toListItem(
  item: GeneratedOrgCompassDevice,
): OrgCompassDeviceListItem {
  return {
    mac_address: item.mac_address,
    serial_number: item.serial_number ?? null,
    firmware_revision: item.firmware_revision ?? null,
    hardware_version: item.hardware_version ?? null,
    is_compass_core: Boolean(item.is_compass_core),
    battery_percentage: item.battery_percentage ?? null,
    compass_alert_mute_status: item.compass_alert_mute_status ?? null,
    last_auth_id: item.last_auth_id ?? null,
    last_user_display_name: item.last_user_display_name ?? null,
    last_user_phone_number: item.last_user_phone_number ?? null,
    last_seen_at: item.last_seen_at,
  };
}

/**
 * All claimed Compass devices for the requestor's org (org resolved server-side
 * from the bearer token). Read-only; returns the web domain shape.
 */
export const getAllOrgCompassDevices = async (): Promise<
  OrgCompassDeviceListItem[]
> => {
  const api = getOrgCompassDevicesApi();
  const response = await api.apiOrgCompassDevicesGetAllGet({});
  return response.map(toListItem);
};
